module.exports = __webpack_public_path__ + "media/images/portal/nsud-logo-d9bf6e517fd132dd75acd36855d4a6bc.png";